<template>
    <div class="NotFound">
        <h1>Érreur chemin incorrecte</h1>
    </div>
</template>

<script>
    import router from "../router/index.js";
    
    export default {
        name: "NotFound",
        data(){
            return{
            }
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>